// Função utilitária para definir o estado ativo do menu
export const Menu = () => {
	const menuToggleButtons = document.querySelectorAll(".btn-menu-toggle");
	const mainMenu = document.querySelector(".main-menu");

	menuToggleButtons.forEach(toggle => {
		toggle.addEventListener("click", () => {
			mainMenu.classList.toggle("active");
			console.log("Menu toggled");
		});
	});
};
